import React from 'react'
import styled from 'styled-components'
import { NftMetadata } from 'config/constants/types'
import BucketImage from 'components/BucketImage'
import { NftCollection } from 'state/collectibles/types'
import { parseUrl } from 'utils/parseUrl'

interface PreviewProps {
  nft: NftMetadata
  collection: NftCollection
  isOwned?: boolean
}

const Container = styled.div`
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.backgroundAlt};
  position: relative;
  width: 100%;
  overflow: hidden;
`

const Preview: React.FC<PreviewProps> = ({ nft, collection }) => {
  let previewImage
  const extension = collection.extension ? collection.extension : nft.image.split(/[#?]/)[0].split('.').pop().trim()
  if (collection.imageOptimized) {
    const key = `${collection.nftAddress}/${nft.tokenId}.${extension}`

    previewImage = <BucketImage location={key} width={600} alt={nft.name} />
  } else previewImage = <img width={600} src={parseUrl(nft.image)} alt={nft.name} style={{ borderRadius: 6 }} />

  return <Container>{previewImage}</Container>
}

export default Preview
